// MBC: layout for the phone pickers (Category, Payee, Account). On a phone the picker is a full-screen page:
// the title and search box stay at the top and only the list scrolls. There is no dimmed background to
// mis-tap, and the size comes from CSS (100dvh), so nothing is resized in JavaScript while the member taps or
// scrolls (doing that on iPhone made taps land on the background and close the picker). React Aria's modal
// already locks the page behind on iPhone. 4 Nov 2026.
import { type CSSProperties } from 'react';

export function useAutocompleteModalLayout(isNarrowWidth: boolean): {
  overlayStyle?: CSSProperties;
  containerStyle: CSSProperties;
  autocompleteContainerStyle: CSSProperties;
} {
  if (!isNarrowWidth) {
    return {
      containerStyle: { height: 275 },
      autocompleteContainerStyle: { height: 275 },
    };
  }

  return {
    overlayStyle: {
      alignItems: 'stretch',
      justifyContent: 'stretch',
      overscrollBehavior: 'contain',
    },
    containerStyle: {
      height: '100dvh',
      maxHeight: '100dvh',
      width: '100vw',
      minWidth: '100vw',
      maxWidth: '100vw',
      borderRadius: 0,
      overflowY: 'hidden',
      paddingTop: 'calc(10px + env(safe-area-inset-top))',
      paddingBottom: 'calc(10px + env(safe-area-inset-bottom))',
    },
    autocompleteContainerStyle: { flex: 1, minHeight: 0 },
  };
}
